export const INIT_INVALID_REG_PAGE = 'src/InvalidRegPage/INIT_INVALID_REG_PAGE'
export const INIT_INVALID_REG_PAGE_SUCCESS =
  'src/InvalidRegPage/INIT_INVALID_REG_PAGE_SUCCESS'
export const INIT_INVALID_REG_PAGE_FAILURE =
  'src/InvalidRegPage/INIT_INVALID_REG_PAGE_FAILURE'
